/* Mobilia header: sticky bar, desktop mega menu, mobile drawer.
   Self-contained so the original header section's header.js is untouched. */
(function () {
	'use strict';

	var DESKTOP = '(min-width: 1400px)';

	/* ---------------------------------------------------------------
	   Value prop strip: only auto-scrolls when the items do not fit.
	   --------------------------------------------------------------- */

	function checkUspScroll() {
		var strips = document.querySelectorAll('.header-mb__usp');
		Array.prototype.forEach.call(strips, function (strip) {
			var inner = strip.querySelector('.header-mb__usp-inner');
			var set = strip.querySelector('.header-mb__usp-set');
			if (!inner || !set) return;
			// The duplicate set is display:none while not scrolling, so measuring
			// the always-visible primary set against the strip's own width is
			// accurate regardless of the strip's current state.
			strip.classList.toggle('is-scrolling', set.scrollWidth > inner.clientWidth);
		});
	}

	/* ---------------------------------------------------------------
	   Sticky bar
	   --------------------------------------------------------------- */

	/* Only float over the homepage's slideshow hero, matching the design; every
	   other page keeps the header pushing content down normally. */
	function checkOverlay(wrapper) {
		if (wrapper.getAttribute('data-header-overlay') !== 'true') return;

		var mainContent = document.querySelector('#MainContent');
		var nextSection = mainContent && mainContent.children[0];
		if (nextSection && nextSection.classList.contains('slideshow-section')) {
			wrapper.classList.add('is-overlay');
		} else {
			wrapper.classList.remove('is-overlay');
		}
	}

	if (!customElements.get('sticky-header-mb')) {
		customElements.define(
			'sticky-header-mb',
			class StickyHeaderMb extends HTMLElement {
				connectedCallback() {
					checkOverlay(this);

					this.type = this.getAttribute('data-sticky-type');
					if (this.type === 'none') {
						this.syncStickyOffset();
						return;
					}

					// Not nextElementSibling: the mega-menu backdrop sits between the
					// header and its spacer.
					this.spacer = this.parentElement.querySelector('[data-header-mb-spacer]');
					this.onResize = this.sizeSpacer.bind(this);
					this.sizeSpacer();
					window.addEventListener('resize', this.onResize, { passive: true });

					this.headerHeight = this.offsetHeight;
					this.lastScroll = 0;
					this.onScroll = this.handleScroll.bind(this);

					if (this.type === 'always') this.classList.add('is-pinned');
					this.syncStickyOffset();
					window.addEventListener('scroll', this.onScroll, { passive: true });
				}

				disconnectedCallback() {
					window.removeEventListener('scroll', this.onScroll);
					window.removeEventListener('resize', this.onResize);
				}

				// position: fixed removes the header from normal flow, so the spacer
				// stands in for the space it would otherwise occupy.
				sizeSpacer() {
					if (this.spacer && this.spacer.classList.contains('header-mb-spacer')) {
						this.spacer.style.height = this.offsetHeight + 'px';
					}
					this.headerHeight = this.offsetHeight;
					document.documentElement.style.setProperty('--header-mb-height', this.headerHeight + 'px');
					this.syncStickyOffset();
				}

				// Collection (and any other) position:sticky elements sit below the
				// visible header. Transform does not change offsetHeight, so a hidden
				// header reports 0 here rather than its full bar height.
				syncStickyOffset() {
					var offset = 0;
					if (this.type !== 'none' && !this.classList.contains('is-hidden')) {
						offset = this.offsetHeight;
					}
					document.documentElement.style.setProperty('--header-mb-sticky-offset', offset + 'px');
				}

				handleScroll() {
					var top = window.pageYOffset || document.documentElement.scrollTop;

					if (top <= this.headerHeight) {
						this.classList.remove('is-stuck', 'is-hidden');
						this.lastScroll = top;
						this.syncStickyOffset();
						return;
					}

					this.classList.add('is-stuck');
					// Scrolling down past the header hides it; scrolling up reveals it.
					if (this.type === 'on-scroll-up') {
						this.classList.toggle('is-hidden', top > this.lastScroll);
					}
					this.lastScroll = top;
					this.syncStickyOffset();
				}
			}
		);
	}

	/* ---------------------------------------------------------------
	   Desktop mega menu
	   --------------------------------------------------------------- */

	var MEGA_MIN_COLUMN_WIDTH = 180; // 18rem
	var MEGA_COLUMN_GAP = 30; // 3rem

	function layoutMegaColumns(roomPanel) {
		var container = roomPanel.querySelector('.mega-mb__columns');
		if (!container) return;

		if (!container._megaItems) {
			container._megaItems = Array.prototype.slice.call(container.querySelectorAll('.mega-mb__column'));
		}
		var items = container._megaItems;
		if (!items.length) return;

		var shopAll = roomPanel.querySelector('.mega-mb__shop-all');

		var available = container.clientWidth;
		if (!available) return;

		var count = Math.floor((available + MEGA_COLUMN_GAP) / (MEGA_MIN_COLUMN_WIDTH + MEGA_COLUMN_GAP));
		count = Math.max(1, Math.min(items.length, count));

		var stacks = [];
		for (var i = 0; i < count; i++) {
			stacks.push(document.createElement('div'));
			stacks[i].className = 'mega-mb__column-stack';
		}

		items.forEach(function (item, index) {
			stacks[index % count].appendChild(item);
		});

		container.innerHTML = '';
		stacks.forEach(function (stack) {
			container.appendChild(stack);
		});

		var lastStack = stacks[stacks.length - 1];
		if (shopAll && lastStack) {
			lastStack.appendChild(shopAll);
			var promo = roomPanel.parentElement.querySelector('.mega-mb__promo');
			if (promo) {
				lastStack.style.minHeight = promo.offsetHeight + 'px';
			}
		}
	}

	function layoutOpenMegaColumns(header) {
		Array.prototype.forEach.call(header.querySelectorAll('.mega-mb__panel.is-active'), function (roomPanel) {
			var mega = roomPanel.closest('.mega-mb');
			if (mega && !mega.hidden) layoutMegaColumns(roomPanel);
		});
	}

	function initMega(header) {
		var layer = header.querySelector('[data-mega-layer]');
		if (!layer) return;

		var triggers = header.querySelectorAll('[data-mega-trigger]');
		if (!triggers.length) return;

		var backdrop = document.querySelector('[data-mega-backdrop]');
		var openPanel = null;
		var openTrigger = null;
		var closeTimer = null;

		function hide(panel, trigger) {
			if (!panel) return;
			panel.classList.remove('is-open');
			if (trigger) trigger.setAttribute('aria-expanded', 'false');
			// Wait for the fade before taking it out of the layout, so the
			// transition is not cut short.
			window.setTimeout(function () {
				if (!panel.classList.contains('is-open')) panel.hidden = true;
			}, 250);
		}

		function close() {
			hide(openPanel, openTrigger);
			openPanel = null;
			openTrigger = null;
			// The search drawer locks the page too; leave that lock alone.
			if (!document.querySelector('#search-modal.active')) {
				document.body.classList.remove('overflow-hidden');
			}
			if (backdrop) {
				backdrop.classList.remove('is-open');
				window.setTimeout(function () {
					if (!backdrop.classList.contains('is-open')) backdrop.hidden = true;
				}, 250);
			}
		}

		function open(trigger) {
			if (!window.matchMedia(DESKTOP).matches) return;
			// The search drawer sits over the header; a menu opening beneath it
			// (hover or focus) would overlap it.
			if (document.querySelector('#search-modal.active')) return;
			// Same for the header's own search results panel (predictive search).
			var headerSearch = header.querySelector('predictive-search');
			if (headerSearch && headerSearch.isOpen) return;

			var panel = document.getElementById(trigger.getAttribute('data-mega-trigger'));
			if (!panel || panel === openPanel) return;

			if (openPanel) hide(openPanel, openTrigger);

			panel.hidden = false;
			// Force a frame so the browser has a starting style to animate from.
			window.requestAnimationFrame(function () {
				panel.classList.add('is-open');
			});
			trigger.setAttribute('aria-expanded', 'true');
			openPanel = panel;
			openTrigger = trigger;
			document.body.classList.add('overflow-hidden');

			if (backdrop) {
				backdrop.hidden = false;
				window.requestAnimationFrame(function () {
					backdrop.classList.add('is-open');
				});
			}

			var activeRoomPanel = panel.querySelector('.mega-mb__panel.is-active');
			if (activeRoomPanel) layoutMegaColumns(activeRoomPanel);
		}

		function cancelClose() {
			window.clearTimeout(closeTimer);
		}

		function scheduleClose() {
			cancelClose();
			closeTimer = window.setTimeout(close, 120);
		}

		Array.prototype.forEach.call(triggers, function (trigger) {
			trigger.addEventListener('mouseenter', function () {
				cancelClose();
				open(trigger);
			});
			trigger.addEventListener('focus', function () {
				cancelClose();
				open(trigger);
			});
			trigger.addEventListener('mouseleave', scheduleClose);
		});

		layer.addEventListener('mouseenter', cancelClose);
		layer.addEventListener('mouseleave', scheduleClose);

		header.addEventListener('focusout', function (event) {
			if (!header.contains(event.relatedTarget)) close();
		});

		// A trigger opens on mouseenter, but clicking something else in the
		// header (the language selector, search, cart...) is neither a
		// mouseleave nor a focusout-from-header, so without this the panel
		// is left stuck open.
		header.addEventListener('click', function (event) {
			if (!openPanel) return;
			if (event.target.closest('[data-mega-trigger]')) return;
			if (event.target.closest('.mega-mb')) return;
			close();
		});

		if (backdrop) {
			backdrop.addEventListener('click', close);
		}

		// Opening the search drawer closes any open mega menu (see search-modal.js).
		document.addEventListener('header:close-mega', close);

		document.addEventListener('keydown', function (event) {
			if (event.key === 'Escape' && openPanel) {
				var trigger = openTrigger;
				close();
				if (trigger) trigger.focus();
			}
		});

		// Room rail: each button swaps the panel beside it.
		Array.prototype.forEach.call(header.querySelectorAll('[data-mega-room]'), function (button) {
			function activate() {
				var mega = button.closest('.mega-mb');
				if (!mega) return;
				var index = button.getAttribute('data-mega-room');

				Array.prototype.forEach.call(mega.querySelectorAll('[data-mega-room]'), function (other) {
					var isMatch = other === button;
					other.classList.toggle('is-active', isMatch);
					other.setAttribute('aria-expanded', isMatch ? 'true' : 'false');
				});

				var matchedPanel = null;
				Array.prototype.forEach.call(mega.querySelectorAll('[data-mega-room-panel]'), function (panel) {
					var isMatch = panel.getAttribute('data-mega-room-panel') === index;
					panel.classList.toggle('is-active', isMatch);
					if (isMatch) matchedPanel = panel;
				});
				if (matchedPanel) layoutMegaColumns(matchedPanel);
			}

			button.addEventListener('mouseenter', activate);
			button.addEventListener('focus', activate);
			button.addEventListener('click', activate);
		});

		var resizeTimer = null;
		window.addEventListener('resize', function () {
			window.clearTimeout(resizeTimer);
			resizeTimer = window.setTimeout(function () {
				if (openPanel && !window.matchMedia(DESKTOP).matches) {
					close();
					return;
				}
				layoutOpenMegaColumns(header);
			}, 150);
		});
	}

	/* ---------------------------------------------------------------
	   Mobile drawer
	   --------------------------------------------------------------- */

	function initDrawer(header) {
		var drawer = document.querySelector('[data-drawer]');
		if (!drawer) return;

		var dialog = drawer.querySelector('.drawer-mb__dialog');
		var openers = header.querySelectorAll('[data-drawer-open]');
		var stack = [];
		var lastOpener = null;

		function levels() {
			return drawer.querySelectorAll('[data-drawer-level]');
		}

		var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

		function swapLevel(id) {
			Array.prototype.forEach.call(levels(), function (level) {
				var isMatch = level.id === id;
				level.classList.toggle('is-active', isMatch);
				level.hidden = !isMatch;
				if (isMatch) level.scrollTop = 0;
			});
		}

		// direction: 1 pushes deeper, -1 goes back, 0 swaps with no motion (first
		// open). Both views move at the same time, like a native push: going deeper
		// the new view slides in from the right while the old one drifts left and
		// fades; going back the previous view comes in from the left while the
		// current one slides out to the right.
		var finishPending = null;

		function showLevel(id, direction) {
			if (finishPending) finishPending();
			var current = drawer.querySelector('[data-drawer-level].is-active');
			var target = document.getElementById(id);
			if (!direction || !current || !target || current === target || reduceMotion.matches || !current.animate) {
				swapLevel(id);
				return;
			}

			var opts = { duration: 280, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)' };
			var anims = [];
			var done = false;
			var enteringOnTop = direction > 0;

			target.hidden = false;
			target.classList.add('is-active');
			target.scrollTop = 0;
			target.style.zIndex = enteringOnTop ? '2' : '1';
			current.style.zIndex = enteringOnTop ? '1' : '2';

			if (direction > 0) {
				anims.push(target.animate([{ transform: 'translateX(100%)' }, { transform: 'none' }], opts));
				anims.push(current.animate(
					[{ transform: 'none', opacity: 1 }, { transform: 'translateX(-25%)', opacity: 0.4 }],
					opts
				));
			} else {
				anims.push(target.animate(
					[{ transform: 'translateX(-25%)', opacity: 0.4 }, { transform: 'none', opacity: 1 }],
					opts
				));
				anims.push(current.animate([{ transform: 'none' }, { transform: 'translateX(100%)' }], opts));
			}

			function finish() {
				if (done) return;
				done = true;
				finishPending = null;
				anims.forEach(function (a) { a.cancel(); });
				current.classList.remove('is-active');
				current.hidden = true;
				current.style.zIndex = '';
				target.style.zIndex = '';
			}
			finishPending = finish;
			anims[0].onfinish = finish;
		}

		function openDrawer() {
			drawer.hidden = false;
			window.requestAnimationFrame(function () {
				drawer.classList.add('is-open');
			});
			document.body.classList.add('overflow-hidden');
			stack = ['HeaderMbLevel-root'];
			showLevel('HeaderMbLevel-root', 0);
			Array.prototype.forEach.call(openers, function (opener) {
				opener.setAttribute('aria-expanded', 'true');
			});
			if (dialog) dialog.focus({ preventScroll: true });
		}

		function closeDrawer() {
			drawer.classList.remove('is-open');
			document.body.classList.remove('overflow-hidden');
			Array.prototype.forEach.call(openers, function (opener) {
				opener.setAttribute('aria-expanded', 'false');
			});
			window.setTimeout(function () {
				if (!drawer.classList.contains('is-open')) drawer.hidden = true;
			}, 250);
			if (lastOpener) lastOpener.focus();
		}

		// Accordion panels slide open / closed instead of snapping.
		function slidePanel(panel, open) {
			if (reduceMotion.matches || !panel.animate) {
				panel.hidden = !open;
				return;
			}
			if (panel._slide) panel._slide.cancel();
			panel.style.overflow = 'hidden';
			if (open) {
				panel.hidden = false;
				var full = panel.scrollHeight;
				panel._slide = panel.animate(
					[
						{ height: '0px', opacity: 0 },
						{ height: full + 'px', opacity: 1 },
					],
					{ duration: 240, easing: 'ease' }
				);
				panel._slide.onfinish = function () {
					panel.style.overflow = '';
					panel._slide = null;
				};
			} else {
				var start = panel.offsetHeight;
				panel._slide = panel.animate(
					[
						{ height: start + 'px', opacity: 1 },
						{ height: '0px', opacity: 0 },
					],
					{ duration: 200, easing: 'ease' }
				);
				panel._slide.onfinish = function () {
					panel.hidden = true;
					panel.style.overflow = '';
					panel._slide = null;
				};
			}
		}

		Array.prototype.forEach.call(openers, function (opener) {
			opener.addEventListener('click', function () {
				lastOpener = opener;
				openDrawer();
			});
		});

		drawer.addEventListener('click', function (event) {
			var close = event.target.closest('[data-drawer-close]');
			if (close) {
				event.preventDefault();
				closeDrawer();
				return;
			}

			var push = event.target.closest('[data-drawer-push]');
			if (push) {
				event.preventDefault();
				var id = push.getAttribute('data-drawer-push');
				if (!document.getElementById(id)) return;
				stack.push(id);
				showLevel(id, 1);

				// A column heading tapped on the rooms level opens that column
				// straight away on the level it pushes to.
				var column = push.getAttribute('data-drawer-open-column');
				if (column !== null) {
					var target = document
						.getElementById(id)
						.querySelector('[data-drawer-column="' + column + '"]');
					if (target && target.getAttribute('aria-expanded') !== 'true') target.click();
				}
				return;
			}

			var pop = event.target.closest('[data-drawer-pop]');
			if (pop) {
				event.preventDefault();
				stack.pop();
				showLevel(stack[stack.length - 1] || 'HeaderMbLevel-root', -1);
				return;
			}

			var accordion = event.target.closest('[data-drawer-accordion]');
			if (accordion) {
				event.preventDefault();
				var panel = document.getElementById(accordion.getAttribute('aria-controls'));
				if (!panel) return;
				var isOpen = accordion.getAttribute('aria-expanded') === 'true';

				// One open at a time: opening a section closes its open siblings (the
				// accordions that share this list), each sliding shut as this one opens.
				if (!isOpen) {
					var group = accordion.closest('ul');
					if (group) {
						Array.prototype.forEach.call(
							group.querySelectorAll('[data-drawer-accordion][aria-expanded="true"]'),
							function (other) {
								if (other === accordion || other.closest('ul') !== group) return;
								var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
								other.setAttribute('aria-expanded', 'false');
								if (otherPanel) slidePanel(otherPanel, false);
							}
						);
					}
				}

				accordion.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
				slidePanel(panel, !isOpen);
			}
		});

		document.addEventListener('keydown', function (event) {
			if (event.key === 'Escape' && !drawer.hidden) closeDrawer();
		});

		// Leaving mobile with the drawer open would otherwise leave the body locked.
		window.matchMedia(DESKTOP).addEventListener('change', function (event) {
			if (event.matches && !drawer.hidden) closeDrawer();
		});
	}

	function init() {
		var header = document.querySelector('[data-header-mb]');
		if (!header) return;
		initMega(header);
		initDrawer(header);
		checkUspScroll();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	// Web font swaps can change the strip's measured width after first paint.
	window.addEventListener('load', checkUspScroll);

	var uspResizeTimer;
	window.addEventListener(
		'resize',
		function () {
			window.clearTimeout(uspResizeTimer);
			uspResizeTimer = window.setTimeout(checkUspScroll, 150);
		},
		{ passive: true }
	);

	// The theme editor re-renders the section on every setting change.
	document.addEventListener('shopify:section:load', function (event) {
		if (event.target.querySelector('[data-header-mb]')) init();

		// Editing the homepage's first section can change whether the header
		// should overlay it, even though the header itself did not reload.
		var wrapper = document.querySelector('.header-mb-wrapper');
		if (wrapper) checkOverlay(wrapper);
	});
})();
